import { createContext, useContext } from "react";

// Toast context split out from the provider component so the .tsx file exports only a
// component (keeps Fast Refresh / react-refresh lint happy).
export type ToastKind = "success" | "error" | "info";
export interface ToastApi {
  success: (message: string) => void;
  error: (message: string) => void;
  info: (message: string) => void;
}

const NOOP: ToastApi = { success: () => {}, error: () => {}, info: () => {} };
export const ToastCtx = createContext<ToastApi>(NOOP);

/** Toast API. Safe no-op if used outside a provider (e.g. login screens). */
export function useToast(): ToastApi {
  return useContext(ToastCtx);
}
